import { Camera, Keyboard, Presentation, Search } from 'lucide-react';
import { useAtlas } from '../app/store.ts';
import { SCENARIOS } from '../scenarios/index.ts';
import { Button, ICON, IconButton, Kbd, Tip } from '../ui/primitives.tsx';
import { downloadCapture } from './capture.ts';

export function Brand() {
  return (
    <div className="brand" aria-label="Brain Atlas">
      <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
        <circle cx="10" cy="10" r="8.25" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.9" />
        <path d="M5.2 11.6c1.6-3.9 4.3-5.7 9.4-5.1M6.6 14.4c1.9-2.6 4.1-3.6 7.7-3.1" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      <span className="ba-type-heading">Brain Atlas</span>
    </div>
  );
}

/** The bar (spec §3, the component sheet's "Top bar"): the mark, the scene tabs on the window's
 *  centre line, then search, a quiet Methods button and three 32 px icon buttons. */
export function TopBar() {
  const scenario = useAtlas((s) => s.scenario);
  const setScenario = useAtlas((s) => s.setScenario);
  const setPalette = useAtlas((s) => s.setPalette);
  const setHelp = useAtlas((s) => s.setHelp);
  const methodsOpen = useAtlas((s) => s.methodsOpen);
  const setMethods = useAtlas((s) => s.setMethods);
  const setPresenting = useAtlas((s) => s.setPresenting);
  return (
    <header className="topbar" data-inset="top">
      <Brand />
      <nav className="scenarios ba-type-body-strong" aria-label="Scenes">
        {SCENARIOS.map((sc) => (
          <Tip key={sc.id} label={sc.tagline} keys={[sc.key]}>
            <button type="button" className={`scenario-tab ${scenario === sc.id ? 'on' : ''}`} aria-current={scenario === sc.id ? 'page' : undefined} style={{ ['--sc' as string]: `var(--sc-${sc.id})` }} onClick={() => setScenario(sc.id)}>
              <span className="dot" aria-hidden="true" />
              {sc.name}
            </button>
          </Tip>
        ))}
      </nav>
      <div className="topbar-actions">
        <button type="button" className="search-trigger ba-type-body" onClick={() => setPalette(true)}>
          <Search size={ICON.sm} />
          <span className="search-label">Search</span>
          <span className="search-keys">
            <Kbd>⌘</Kbd>
            <Kbd>K</Kbd>
          </span>
        </button>
        <Button variant="quiet" aria-pressed={methodsOpen} onClick={() => setMethods(!methodsOpen)}>
          Methods
        </Button>
        <IconButton size="lg" icon={Presentation} label="Presentation: the picture only" keys={['P']} onClick={() => setPresenting(true)} />
        <IconButton size="lg" icon={Camera} label="Capture an image" keys={['C']} onClick={() => void downloadCapture()} />
        <IconButton size="lg" icon={Keyboard} label="Keyboard shortcuts" keys={['?']} onClick={() => setHelp(true)} />
      </div>
    </header>
  );
}
